import { ComponentParameterEnhancerFunction } from "@uniformdev/canvas";

import { ProductCatalogClient } from "@/contentful/product-catalog.tsx";
import {
    checkFeatureFlagGate,
    featureFlags
} from "@/utils/feature-flags/index.ts";
import { isProduction } from "@/utils/urls.ts";

const PRODUCT_CATALOG_DELIVERY_KEY =
    process.env["PRODUCT_CATALOG_DELIVERY_KEY"];
const PRODUCT_CATALOG_SPACE = process.env["PRODUCT_CATALOG_SPACE"];

export const getContentfulEnvironment = () => {
    if (isProduction()) {
        return "master";
    }
    const isCcpStaging = checkFeatureFlagGate(
        featureFlags.gwp9034WacPricingCcpStaging
    );
    return isCcpStaging ? "ccp_staging" : "master";
};

export const comparePlansEnhancer: ComponentParameterEnhancerFunction<
    Plan[]
> = async ({ parameter }) => {
    const plans = parameter.value;
    if (!plans?.length) {
        return parameter.value;
    }

    const contentfulEnvironment = getContentfulEnvironment();
    const productCatalogClient = new ProductCatalogClient(
        String(PRODUCT_CATALOG_DELIVERY_KEY),
        String(PRODUCT_CATALOG_SPACE),
        contentfulEnvironment
    );

    const skus = plans.map((plan) => plan.fields.sku);

    const ccpPricingData = await productCatalogClient.getCCPPricingData(skus);

    return plans.map((plan) => ({
        ...plan,
        pricingPlan: ccpPricingData[plan.fields.sku]
    }));
};

export type Plan = {
    fields: {
        sku: string;
    };
};
